module.exports = {"id":"214097","name":"Benjamin Bourigeaud","rating":"73","photo":"./data/images/photos/2/214097.png","club":{"name":"Stade Rennais","logo":"./data/images/clubs/StadeRennais.png"},"positions":["MD","MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BenjaminBourigeaud0.json
// module id = 566
// module chunks = 0